import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import './MaterialSwiper.scss';
import { useFormikContext } from 'formik';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';

type Props = {};
export const MaterialSwiper = (props: Props) => {
    const { values } = useFormikContext<IFormikForm>();
    const mat = values[values.sectorChannel].material;
    return (
        <>
            {!!mat && (
                <div>
                    <Swiper modules={[Navigation, Pagination]} spaceBetween={0} slidesPerView={1} navigation pagination={{ type: 'fraction' }}>
                        {!!mat.images &&
                            mat.images?.map(img => (
                                <SwiperSlide style={{ padding: '0% 10%' }} key={img.id}>
                                    {!!img.url ? <img src={img.url} /> : null}
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>
            )}
        </>
    );
};
